const formatTimingPrefix = () => {
    const { pathname } = window.location;
    // Format the pathname with dashes for ease of searching sentry dashboard
    return pathname.slice(1).replaceAll("/", "-");
};

export default formatTimingPrefix;
